export default new class Accordion {
  constructor() {
    this.selectors = {
      accordion: '.js-accordion',
      toggle: '.js-accordion-toggle',
    };

    if (!document.querySelector(this.selectors.accordion)) return;
    this.parent = document.querySelector(this.selectors.accordion);
    this.init(this.parent);
  }

  init(parent) {
    this.bindToggleEvent(parent);
  }

  bindToggleEvent(parent) {
    const toggles = this.getToggles(parent);

    toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const itemParent = toggle.parentNode;
        const sibling = toggle.nextElementSibling;
        const isActive = itemParent.classList.contains('is-open');
        Accordion.a11yToggle(toggle);
        this.collapseOpen(parent);

        if (isActive) {
          return;
        }

        itemParent.classList.add('is-open');
        sibling.style.maxHeight = `${sibling.scrollHeight}px`;
      });
    });
  }

  getToggles(parent) {
    return parent.querySelectorAll(this.selectors.toggle);
  }

  static a11yToggle(elem) {
    const parent = elem.parentNode;
    const sibling = elem.nextElementSibling;
    if (parent.classList.contains('is-open')) {
      elem.setAttribute('aria-expanded', false);
      sibling.setAttribute('aria-hidden', true);
    } else {
      elem.setAttribute('aria-expanded', true);
      sibling.setAttribute('aria-hidden', false);
    }
  }

  collapseOpen(parent) {
    const toggles = this.getToggles(parent);
    toggles.forEach(toggle => {
      const itemParent = toggle.parentNode;
      if (itemParent.classList.contains('is-open')) {
        Accordion.a11yToggle(toggle);
        const sibling = toggle.nextElementSibling;
        itemParent.classList.remove('is-open');
        sibling.style.maxHeight = 0;
      }
    });
  }
}();



// WEBPACK FOOTER //
// ./src/scripts/modules/accordion.js